import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../../services/api'
import { Box, CREToolTab, IconButton, Text, Map, Card, HelperButton } from '../../components'
import theme from '../../theme'
import OfficeCard from '../../components/office/OfficeCard'
import { format } from 'date-fns'
import { OfficeCompaniesLogos } from '../../components/office/OfficeCompaniesLogos'
import { OfficeSimilarBuildingCard } from '../../components/office/OfficeSimilarBuildingCard'
import { OfficeTransactionGrid } from '../../components/office/OfficeTransactionGrid'
import { PieChartOccupation } from '../../components/office/PieChartOccupation'
import { BarChartOccupationHistory } from '../../components/office/BarChartOccupationHistory'
import { ShoppingsNearCard } from '../../components/office/ShoppingsNearCard'
import { NextButton, PrevButton } from '../../components/Button'
import { EvaluationCard as EvaluationCardNew } from '../../components/office/evaluation/EvaluationCardNew'
import classeIcon from '../../../assets/icons/classe_buildings.svg'
import perfilIcon from '../../../assets/icons/perfil.svg'
import dataEntregaIcon from '../../../assets/icons/data_entrega.svg'
import statusIcon from '../../../assets/icons/check.svg'
import areaLocavelTotalIcon from '../../../assets/icons/area_locavel_total.svg'
import areaDispIcon from '../../../assets/icons/area_disp.svg'
import vacanciaIcon from '../../../assets/icons/vacancia.svg'
import AbsorvicaoIcon from '../../../assets/icons/absorvisao_liquida.svg'
import NoBuildingImage from '../../../assets/icons/no_building_image.png'
import { useApp } from '../../../contexts'
import { getImageLabel, translateText } from '../../../helpers/util'

const Dashboard = () => {
    const { officeId, accessToken } = useParams()
    const [office, setOffice] = useState({})
    const [permissions, setPermissions] = useState([])
    const [markers, setMarkers] = useState([])
    const { setBuildingCountry } = useApp()

    useEffect(() => {
        getPermissions();
        loadOfficeData({ firstLoad: true })
    }, []);

    useEffect(() => {
        prepareMarkers(office);
    }, [office]);

    const getPermissions = async () => {
        const params = { permissions: "transacao,menuEstatistica" }
        const config = {}
        if (accessToken !== "") {
            config.headers = {
                'Authorization': 'Bearer ' + accessToken,
                "Content-Type": "application/json"
            }
        }
        const response = await api.post(`/user/permission`, params, config)
        const { data: permissions } = response
        Promise.all([response]).then((values) => {
            setPermissions(permissions.data)
        }).catch(err => {
            console.log(err)
        });
    }

    const loadOfficeData = async ({ firstLoad = false }) => {
        const config = {}
        if (accessToken !== "") {
            config.headers = {
                'Authorization': 'Bearer ' + accessToken
            }
        }

        const response = await api.get(`/office/${officeId}/dashboard`, config)
        const { data: officeData } = response

        Promise.all([response]).then((values) => {
            setOffice(officeData)
            setBuildingCountry(officeData.specs.pais)
            prepareMarkers(officeData)
        }).catch(err => {
            console.log(err)
        });
    }

    const prepareMarkers = (office) => {
        const { specs, similarBuildings, nearShoppings } = office

        if (!specs) return

        const similarBuildingsMarkers = similarBuildings.map((building, index) => {
            return { lat: building.lat, lng: building.log, html: building.nome, markerType: 'point', number: index + 1 }
        })

        const nearShoppingsMarkers = nearShoppings.map((shopping, index) => {
            return { lat: shopping.lat, lng: shopping.log, html: shopping.nome, markerType: 'pointShopping', number: similarBuildings.length + index + 1 }
        })

        let marker = [...markers, { lat: specs.lat, lng: specs.log, html: specs.nome }, ...similarBuildingsMarkers]

        if (specs.pais === "Brasil") {
            marker.push(...nearShoppingsMarkers);
        }
        setMarkers(marker)
    }

    return (
        <CREToolTab>
            <ColumnLayout office={office} markers={markers} permissions={permissions} ></ColumnLayout>
        </CREToolTab>
    )
}

const ColumnLayout = ({ office, markers, permissions, handlePeriodChange, period, handleCapRateChange, handleVMLIChange }) => {

    const [activeSimilarBuilding, setActiveSimilarBuilding] = useState(0)
    const [activeShoppingNear, setActiveShoppingNear] = useState(0)
    const [vmvi, setVmvi] = useState(null)
    const { specs, images = [], tenants, owners, similarBuildings, nearShoppings, transactions, occupationProfile, occupationHistory, capRate, history } = office
    const { userCountry, language, translations } = useApp()

    const handleVMVI = (newValue) => {
        setVmvi(newValue)
    }

    return <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
        {specs && <>
            <OfficeHeader specs={specs} />
            <div style={{ display: 'flex', marginTop: 10, flexDirection: 'row' }}>

                {/* Dados a esquerda do layout */}
                <div style={{ width: 450, marginRight: 10 }}>
                    <OfficeImages images={images} />
                    {specs && <OfficeAdress specs={specs} />}
                    <Box sx={{ flexDirection: 'column', display: 'flex', marginBottom: 1, maxWidth: 450, marginTop: 1 }}>
                        <Card>
                            <Map
                                markers={markers}
                                center={{ lat: specs.lat, lng: specs.log }}
                            />
                            <Text style={{ fontSize: 14, color: "#7a7b7c", marginLeft: 5, fontWeight: "600" }}>{translateText("Edifícios Semelhantes", language, translations, userCountry)}</Text>
                            <div style={{ flexDirection: 'row', display: 'flex', padding: 1, position: 'relative', marginTop: 4, marginBottom: 4 }}>
                                <div style={{ position: 'absolute', left: 0, top: '25%', zIndex: "1" }}>
                                    {activeSimilarBuilding > 0 &&
                                        <PrevButton onClick={() => {
                                            setActiveSimilarBuilding(activeSimilarBuilding - 1)
                                        }} />
                                    }
                                </div>
                                {similarBuildings.map((building, index) => {
                                    return <OfficeSimilarBuildingCard key={`similarBuilding_${index}`} building={building} index={index + 1} />
                                }).filter((building, index) => index >= activeSimilarBuilding)}
                                <div style={{ position: 'absolute', right: 0, top: '25%', zIndex: "1" }}>
                                    {activeSimilarBuilding < similarBuildings.length - 1 &&
                                        <NextButton onClick={() => {
                                            setActiveSimilarBuilding(activeSimilarBuilding + 1)
                                        }} />
                                    }
                                </div>
                            </div>
                            {specs.pais === "Brasil" &&
                                <>
                                    <Text style={{ fontSize: 14, color: "#7a7b7c", marginLeft: 5, fontWeight: "600" }}>{translateText("Shoppings Próximos", language, translations, userCountry)}</Text>
                                    <div style={{ flexDirection: 'row', display: 'flex', padding: 1, position: 'relative', marginTop: 4, marginBottom: 10 }}>
                                        <div style={{ position: 'absolute', left: 0, top: '25%', zIndex: "1" }}>
                                            {activeShoppingNear > 0 &&
                                                <PrevButton onClick={() => {
                                                    setActiveShoppingNear(activeShoppingNear - 1)
                                                }} />
                                            }
                                        </div>
                                        {nearShoppings.map((shopping, index) => {
                                            return <ShoppingsNearCard key={`nearShopping_${similarBuildings.length + index + 1}`} shopping={shopping} index={similarBuildings.length + index + 1} />
                                        }).filter((shopping, index) => index >= activeShoppingNear)}
                                        <div style={{ position: 'absolute', right: 0, top: '25%', zIndex: "1" }}>
                                            {activeShoppingNear < nearShoppings.length - 1 &&
                                                <NextButton onClick={() => {
                                                    setActiveShoppingNear(activeShoppingNear + 1)
                                                }} />
                                            }
                                        </div>
                                    </div>
                                </>
                            }
                        </Card>
                    </Box>
                </div>

                {/* Dados a direita do layout */}
                {specs &&
                    <>
                        <div style={{ flex: 1 }}>
                            <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1 }}>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={vacanciaIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(parseFloat(specs.taxa_vacancia).toFixed(1))}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Taxa de Vacância", language, translations, userCountry)} (%)</Text>
                                    </Box>
                                </OfficeCard>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={dataEntregaIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{specs.status == "Em Projeto" ? "-" : format(new Date(specs.data_entrega), 'MM/yyyy')}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Data de Entrega", language, translations, userCountry)}</Text>
                                    </Box>
                                </OfficeCard>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={areaLocavelTotalIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(specs.area_locavel_total)}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Área Locável Total", language, translations, userCountry)} (m2)</Text>
                                    </Box>
                                </OfficeCard>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={classeIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{specs.classe}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Classe", language, translations, userCountry)}</Text>
                                    </Box>
                                </OfficeCard>
                            </Box>
                            <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1 }}>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={AbsorvicaoIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(specs.absorcao_liquida)}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Absorção Líquida", language, translations, userCountry)} (m2)</Text>
                                    </Box>
                                </OfficeCard>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={statusIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 14, fontWeight: '700', color: '#464648' }}>{translateText(specs.status, language, translations, userCountry)}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Status", language, translations, userCountry)}</Text>
                                    </Box>
                                </OfficeCard>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={areaDispIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(specs.area_locavel_disponivel)}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Área Disponível", language, translations, userCountry)} (m2)</Text>
                                    </Box>
                                </OfficeCard>
                                <OfficeCard>
                                    <Box sx={styles.boxImage}>
                                        <img src={perfilIcon} width={24} height={24} />
                                        <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{translateText(specs.perfil, language, translations, userCountry)}</Text>
                                    </Box>
                                    <Box>
                                        <Text style={{ fontSize: 11 }}>{translateText("Perfil de Ocupação", language, translations, userCountry)}</Text>
                                    </Box>
                                </OfficeCard>
                            </Box>
                            {
                                (permissions.includes("transacao")) ? (
                                    (specs.cidade == "São Paulo" || specs.cidade == "Rio de Janeiro" || specs.cidade == "Barueri" || specs.cidade == "Santiago" || specs.cidade == "Puerto Montt" || specs.cidade == "Região de Bío-Bío" || specs.cidade == "Coquimbo") ? (
                                        <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1 }}>
                                            <EvaluationCardNew handleVMVI={handleVMVI} officeId={specs.id_edificio} />
                                        </Box>
                                    ) : ""
                                ) : ""
                            }
                            <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1, height: 300, overflow: "hidden", overflowY: 'auto' }}>
                                <OfficeCard>
                                    <PieChartOccupation officeId={specs.id_edificio} />
                                </OfficeCard>
                                {
                                    (permissions.includes("menuEstatistica")) ? (
                                        <OfficeCard>
                                            <BarChartOccupationHistory officeId={specs.id_edificio} />
                                        </OfficeCard>
                                    ) : ""
                                }
                            </Box>
                            <Box sx={{ flexDirection: 'row', display: 'flex', marginBottom: 1, height: 350 }}>
                                <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                                    <OfficeCard sx={{ marginBottom: 1 }}>
                                        <OfficeCompaniesLogos officeId={specs.id_edificio} />
                                    </OfficeCard>
                                    <OfficeCard>
                                        <OfficeCompaniesLogos officeId={specs.id_edificio} type={'owners'} />
                                    </OfficeCard>
                                </Box>
                                {
                                    (permissions.includes("transacao")) ? (
                                        <Box sx={{ display: 'flex', flex: 1 }}>
                                            <OfficeCard>
                                                <OfficeTransactionGrid officeId={specs.id_edificio} vmvi={vmvi} />
                                            </OfficeCard>
                                        </Box>
                                    ) : ""
                                }
                            </Box>
                        </div>
                    </>
                }

            </div>
        </>}
    </div>
}

const OfficeHeader = ({ specs }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ paddingLeft: 10, flex: 1 }}>
                <div style={{ fontSize: 20, fontWeight: '600', color: theme.palette.primary.main, marginBottom: 10 }}>{specs.nome}</div>
            </div>
        </div>
    )
}

const OfficeAdress = ({ specs }) => {
    const { userCountry, language, translations } = useApp()

    return <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: 1 }}>
        <OfficeCard sx={{ marginRight: 0 }}>


            <span style={{ fontSize: 14 }}>
                <div>{translateText("Endereço", language, translations, userCountry)}: {specs.endereco}, {specs.numero}</div>
                {specs.pais !== "Chile" &&
                    <div>{translateText("Região Buildings", language, translations, userCountry)}: {specs.regiao_2}</div>
                }
                <div>{translateText("Cidade", language, translations, userCountry)}: {specs.cidade} - {specs.uf}</div>
                {specs.nome_administradora !== "" &&
                    <div>{translateText("Administradora das Áreas comuns", language, translations, userCountry)}: {specs.nome_administradora}</div>
                }
            </span>

        </OfficeCard>
    </Box>
}

const OfficeImages = ({ images }) => {

    const { userCountry, language, translations } = useApp()
    const [imgIndex, setImgIndex] = useState(0)

    return <div style={{ position: 'relative', borderRadius: 4, width: 450, height: 450, overflow: 'hidden' }}>
        {images && images.length > 0 ? (
            <>
                <img src={`https://d6bmyxfy7viyd.cloudfront.net/${images[imgIndex]?.url}`} width='450' height='450' style={{ borderRadius: 4, objectFit: 'cover' }} />
                <div style={{ backgroundColor: '#32587D', height: 50, width: '100%', position: 'absolute', bottom: 0, zIndex: 10, opacity: 0.8, borderBottomRightRadius: 4, borderBottomLeftRadius: 4 }}>
                </div>
                <div style={{ height: 50, width: '100%', position: 'absolute', bottom: 0, zIndex: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {imgIndex > 0 ? (
                        <PrevButton onClick={() => setImgIndex(imgIndex - 1)} />
                    ) : (
                        <div style={{ width: 40 }} />
                    )}
                    <div style={{ color: '#FFF', flex: 1, justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 14 }}>
                        {
                            getImageLabel(images[imgIndex].nome, language, translations, userCountry)
                        }
                    </div>
                    {imgIndex < images.length - 1 ? (
                        <NextButton onClick={() => setImgIndex(imgIndex + 1)} />
                    ) : (
                        <div style={{ width: 40 }} />
                    )}
                </div>
            </>
        ) : (
            <div style={styles.noImageContainer}>
                <img src={NoBuildingImage} width='450' height='450' style={{ objectFit: 'cover' }} />
                <div style={styles.noImageOverlay}>
                    {translateText("Imagem do edifício não disponível", language, translations, userCountry)}
                </div>
            </div>
        )}
    </div>
}

const styles = {
    boxImage: {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    noImageContainer: {
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#EAEAEA',
        boxSizing: 'border-box',
        zIndex: 1
    },
    noImageOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        color: '#FFF',
        fontSize: 14,
        textAlign: 'center',
        padding: '12px 10px',
        fontWeight: '600',
        lineHeight: '1.2',
        wordBreak: 'break-word',
        fontFamily: 'sans-serif',
        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4
    }
}

export default Dashboard